import { ConfigurableProps } from 'widget/PodcastProfile/types';
import { pickBy } from 'lodash-es';
import { Request } from 'express';

/*
 * Removes certain props based on query string settings
 */
export default function applyConfigToProps(
  props: ConfigurableProps,
  query: Request['query'] = {},
): ConfigurableProps {
  const { description = 'true', thumbnail = 'true' } = query;

  const propsToKeep: {
    [key: string]: boolean;
  } = {
    description: description === 'true',
    imageUrl: thumbnail === 'true',
  };

  const propsFilter = (val: string, key: string) => propsToKeep[key];

  return pickBy(props, propsFilter);
}
